import { Type, Size, type Align } from '../../../core/enums';
import makeAtom from '../../../core/makeAtom';
import type { Theme, Tools } from '../../../core/types';
import withEventTracking from '../../../utilities/withEventTracking';
import styles from './index.module.less';

interface Props {
  Component?: keyof React.ReactHTML | React.ElementType;
  children?: React.ReactNode;
  className?: string;
  theme?: Theme;
  href?: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  type?: 'submit' | 'reset' | 'button';
  $type?: Type;
  $size?: Size;
  $align?: Align;
  tools?: Tools;
  target?: string;
  disabled?: boolean;
  qeId?: string;
  $isMinMax?: boolean;
  $textWrap?: boolean;
  $shape?: 'regular' | 'pill';
  $shadow?: boolean;
  id?: string;
  tabIndex?: number;
  role?: string;
  forwardedRef?: React.Ref<HTMLButtonElement>;
}

export const Button = makeAtom<Props>({
  name: 'Button',
  rootClass: styles.btn,
  defaultProps: {
    Component: 'button',
    $type: Type.Primary,
    tools: {
      tracking: {
        methods: ['click'],
      },
    },
    $shape: 'regular',
    $shadow: false,
  },
  styles,
  modifiersToDLSMap: {
    $type: {
      primary: [],
      secondary: [styles.btnSecondary],
      tertiary: [styles.btnTertiary],
    },
    $size: {
      sm: [styles.btnSm],
    },
    $shape: {
      regular: [],
      pill: [styles.pill],
    },
    $align: {},
  },
  mapModifiersToTheme: ({ $size }) => ({
    textBody: $size === Size.SM ? 1 : 3,
  }),
});

/**
 * @deprecated
 * DEPRECATION NOTICE:
 * This component should not be used and will be removed [in V2](https://github.aexp.com/amex-eng/aqx-components/tree/next)
 *
 * Please migrate to the [DLS Button component](https://design.aexp.com/components/actions/buttons/)
 */
export default withEventTracking<Props>(Button);
